/* istanbul ignore file */
const codeSnippetsServiceUrl = (() => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  // use staging domain for non-production envs
  if (
    hostname.includes('eod') ||
    hostname.includes('nightly') ||
    hostname.includes('staging') ||
    hostname.includes('127.0.0.1') ||
    hostname.includes('0.0.0.0') ||
    hostname.includes('localhost')
  ) {
    return 'https://staging-code-snippets.cloudinary.com';
  }

  return 'https://production-code-snippets.cloudinary.com';
})();

export { codeSnippetsServiceUrl };
